import { useEffect, useState } from "react";
import { getFeatureFlags } from "../../shared/featureFlagService";

/**
 * Custom hook to manage the locale switcher feature flag
 * Reads `shouldShowLocaleSwitcherAdminECM` from the dataservice /features API.
 * @returns {boolean} isLocaleSwitcherEnabled - Whether the locale switcher is enabled
 */
export const useLocaleSwitcherFeatureFlag = (): boolean => {
    const [isLocaleSwitcherEnabled, setIsLocaleSwitcherEnabled] = useState(false);

    useEffect(() => {
        const fetchFeatureFlags = async (): Promise<unknown> => {
            return await getFeatureFlags("one-web-domain");
        };

        fetchFeatureFlags()
            .then((flags: unknown) => {
                if (
                    typeof flags === "object" &&
                    flags !== null &&
                    Object.prototype.hasOwnProperty.call(flags, "shouldShowLocaleSwitcherAdminECM")
                ) {
                    setIsLocaleSwitcherEnabled(
                        (flags as { shouldShowLocaleSwitcherAdminECM: boolean })
                            .shouldShowLocaleSwitcherAdminECM
                    );
                }
            })
            .catch((error: unknown) => {
                // eslint-disable-next-line no-console
                console.error("Failed to fetch feature flags:", error);
            });
    }, []);

    return isLocaleSwitcherEnabled;
};
